import { createStore } from "zustand/vanilla";

/**
 * Notificaciones del OS (os §1): toast 4 s + centro persistente con badge.
 * SIEMPRE diegéticas — el shell nunca habla "como juego": el texto lo firman
 * la Agencia, M. o las apps. El timer vive en la UI (aquí solo estado puro,
 * testeable en node).
 */

export interface Notification {
  id: number;
  /** Quién la firma diegéticamente: "M.", "Mail", "Archivo", "Sistema"… */
  source: string;
  text: string;
  at: number;
  read: boolean;
  /** Sigue visible como toast (la UI la baja a los 4 s) */
  toast: boolean;
}

export interface NotificationStoreState {
  items: Notification[];
  nextId: number;
  push: (source: string, text: string, at: number) => number;
  /** Baja el toast (pasa al centro; no la marca leída) */
  settle: (id: number) => void;
  markAllRead: () => void;
  unreadCount: () => number;
}

export function createNotificationStore() {
  return createStore<NotificationStoreState>()((set, get) => ({
    items: [],
    nextId: 1,

    push: (source, text, at) => {
      const id = get().nextId;
      set((s) => ({
        items: [{ id, source, text, at, read: false, toast: true }, ...s.items],
        nextId: id + 1,
      }));
      return id;
    },

    settle: (id) =>
      set((s) => ({
        items: s.items.map((n) => (n.id === id ? { ...n, toast: false } : n)),
      })),

    markAllRead: () => set((s) => ({ items: s.items.map((n) => ({ ...n, read: true })) })),

    unreadCount: () => get().items.filter((n) => !n.read).length,
  }));
}

export const notificationStore = createNotificationStore();
